export default function smScreenViews() {
  const MOBILE_MQ = "(max-width: 1099px)";

  // Return the details panel that belongs to the same `[data-main-view]`
  // as the clicked trigger. Using `closest()` avoids the previous bug
  // where a single document-wide querySelector always resolved to the
  // FIRST `[data-details]` in the DOM (the builder partial), which meant
  // triggers inside the furniture view could never open their own panel.
  function findDetailsPanelFor(element) {
    const scope = element.closest("[data-main-view]") || document;
    return scope.querySelector("[data-details]");
  }

  document.addEventListener("click", (event) => {
    if (!window.matchMedia(MOBILE_MQ).matches) {
      return;
    }

    const openTrigger = event.target.closest("[data-trigger-details]");
    if (openTrigger) {
      const detailsView = findDetailsPanelFor(openTrigger);
      if (detailsView) {
        detailsView.classList.add("active");
      }
      return;
    }

    const closeTrigger = event.target.closest("[data-details-close]");
    if (closeTrigger) {
      const detailsView = findDetailsPanelFor(closeTrigger);
      if (detailsView) {
        detailsView.classList.remove("active");
      }
    }
  });
}
